module.exports = __webpack_public_path__ + "img/verification-img.388ef2fb.png";